import "./scss/custom";

const downloads = document.querySelectorAll(".download");

downloads.forEach(d => {
  const href = d.getAttribute("href");
  const dataHref = d.getAttribute("data-href");
  d.setAttribute("href", href.replace("index.html", dataHref));
});
